let required = (property) => {
  return (v) => !!v || `${property}${" :必須項目です"}`;
};

let email = () => {
  return (v) =>
    (v && /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)) ||
    "有効なメールアドレスを入力してください";
};

let password = (property) => {
  return (v) =>
    (v && passwordCriteria(v)) ||
    `あなたの ${property} パスワード条件：（必須）長さ8文字以上からなる（必須）英大文字を1文字以上含む（必須）英小文字を1文字以上含む（必須）記号または数字を1文字以上含む`;
};

let passwordWithEmail = (property, fullEmail) => {
  return (v) =>
    (v && fullEmail && passwordEmailCheck(v, fullEmail)) ||
    `${property} メールアドレスを含めることはできません`;
};

let passwordWithName = (property, name, otherProperty) => {
  return (v) =>
    (v && passwordNameCheck(v, name)) ||
    `${property} 含めることはできません ${otherProperty}`;
};
let lowercase = (property) => {
  return (v) =>
    (v && /^[a-z]+$/.test(v)) || `${property} must be in lowercase.`;
};

// checking password length and password criteria
const passwordCriteria = (pw) => {
  let criteria = 0;
  if (pw.toUpperCase() != pw) {
    // has lower case letters
    criteria++;
  }
  if (pw.toLowerCase() != pw) {
    // has upper case letters
    criteria++;
  }
  if (/^[a-zA-Z0-9]*$/.test(pw) === false) {
    // has special characters
    criteria++;
  }
  if (/\d/.test(pw) === true) {
    // has numbers
    criteria++;
  }
  // returns true if 3 or more criteria was met and length is appropriate
  return criteria >= 3 && pw.length >= 8;
};

// email username cheking with password -> is email username includes in user password
const passwordEmailCheck = (password, email) => {
  let emailUserName = email.split("@")[0];
  let emailOrganizationName = email.split("@")[1].split(".")[0];
  let fullEmail = emailUserName + emailOrganizationName;
  let checkEmail = fullEmail
    .match(/.{3}/g)
    .concat(
      fullEmail.substr(1).match(/.{3}/g),
      fullEmail.substr(2).match(/.{3}/g)
    );
  let isCheckEmail = new RegExp(checkEmail.join("|"), "i").test(password);
  return !isCheckEmail;
};

// user Name and Display name is checking with password -> is user name and display name include in password?
const passwordNameCheck = (password, name) => {
  if (!password || !name || name.trim().length < 3) return true;
  let newName = name.trim();
  while (newName.length > 0 && newName.length < 5) {
    newName = newName.repeat(2);
  }
  let checkName = newName
    .match(/.{3}/g)
    .concat(newName.substr(1).match(/.{3}/g), newName.substr(2).match(/.{3}/g));

  let isCheckName = new RegExp(checkName.join("|"), "i").test(password);
  return !isCheckName;
};

let match = (property) => {
  return (v) => (v === property) || "パスワードが一致しません";
};

export default {
  required,
  email,
  password,
  passwordWithEmail,
  passwordWithName,
  lowercase,
  match,
};
